import React from 'react';
import { Reveal } from './Reveal';
import { materialPreviews } from '../data/materialPreviews';
export function MaterialPreviewSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-134" data-mp="14vnqzcgc3sgc">
      <Reveal className="mx-auto max-w-6xl" data-id="element-135" data-mp="1jj0gfc99iic0">
        <div className="mx-auto mb-10 max-w-2xl text-center" data-id="element-136" data-mp="1jktq70f69io8">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-137" data-mp="1eqz8u3n1hfsb">
            PAGINE REALI DAL PACCHETTO
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-138" data-mp="1ohtxfenrcrgx">Uno sguardo dentro il materiale</h2>
          <p className="mt-4 text-sm leading-relaxed text-muted md:text-base" data-id="element-139" data-mp="22i4mqd9f5xzz">
            Sequenze illustrate, schede esercizio e piani di lezione già impaginati: queste sono pagine vere, prese dai
            volumi che riceverai.
          </p>
        </div>

        <ul className="-mx-4 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-4 [scrollbar-width:thin]" data-id="element-140" data-mp="85evk3afr2wa">
          {materialPreviews.map(({
          image,
          title,
          caption
        }) => <li key={title} className="flex w-[248px] shrink-0 snap-start flex-col overflow-hidden rounded-xl border border-line bg-white shadow-soft sm:w-[272px]" data-id="element-141" data-mp="2hzab5lke6wrh">
              <div className="flex h-[330px] items-center justify-center overflow-hidden bg-sand p-3 sm:h-[360px]" data-id="element-142" data-mp="2qw12jko01nfq">
                <img src={image} alt={`Pagina di esempio: ${title}`} loading="lazy" className="h-full w-full rounded object-contain" data-id="element-143" data-mp="2vqoqnif3cfts" />
              </div>
              <div className="flex flex-1 flex-col border-t border-line px-5 py-4" data-id="element-144" data-mp="3an64qheo08k1">
                <h3 className="font-heading text-sm font-semibold leading-snug text-petrol" data-id="element-145" data-mp="3eo84r0geoon2">{title}</h3>
                <p className="mt-1.5 font-note text-xs leading-relaxed text-muted" data-id="element-146" data-mp="1g8vfw8y2lee9">{caption}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 text-center font-note text-xs text-muted" data-id="element-147" data-mp="1kbrtfl8r6kbc">
          Scorri per vedere altre pagine · Tutti i file sono in PDF A4 a 300 DPI, pronti da stampare
        </p>
      </Reveal>
    </section>;
}